import noop from 'lodash-es/noop';
import React, {useState} from 'react';
import styled from 'styled-components';
import YoutubeVideo from '../../sharedComponents/YoutubeVideo';
import { primaryColor1 } from '../Utils';

const fullScreenStyles = `
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
`;

const Root = styled.div`
  position: fixed;
  ${fullScreenStyles}
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;

const Overlay = styled.div`
  position: absolute;
  ${fullScreenStyles}
  background-color: rgba(0, 0, 0, 0.3);
`;

const TutorialContainer = styled.div`
  width: 75vw;
  padding: 4vh 4vh 0 4vh;
  background-color: #fff;
  position: relative;
`;

const Grid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 200px;
  grid-column-gap: 1rem;
`;

const TableOfContents = styled.div`
  display: flex;
  flex-direction: column;
`;

const TOCTitle = styled.h3`
  margin: 0 0 0.8rem;
  font-weight: 400;
  color: #575e5f;
`;

const ContentButton = styled.button`
  text-align: left;
  border: none;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  padding: 0.2rem;
  color: ${primaryColor1};
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
    background-color: #dbeaf9;
  }
`;

const Time = styled.strong`
  margin-right: 0.45rem;
`;
const Title = styled.span`
  text-decoration: underline;
`;

const CloseButton = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.4rem;
  font-size: 2rem;
  color: #666;
  cursor: pointer;
`;
export const timeToTimeStamp = (m: string, s: string) => (parseInt(m, 10) * 60) + parseInt(s, 10);

export interface Chapter {
  title: string;
  minute: string;
  second: string;
}

export const chapters: Chapter[] = [
  { // 0
    title: 'What are Country Profiles?',
    minute: '0',
    second: '00',
  },
  { // 1
    title: 'How do countries grow?',
    minute: '0',
    second: '52',
  },
  { // 2
    title: 'How to navigate Country Profiles',
    minute: '1',
    second: '29',
  },
  { // 3
    title: 'Understanding country exports',
    minute: '1',
    second: '45',
  },
  { // 4
    title: 'Dynamics of country exports',
    minute: '2',
    second: '21',
  },
  { // 5
    title: 'Market share of country exports',
    minute: '2',
    second: '39',
  },
  { // 6
    title: 'Diversifying into new products',
    minute: '3',
    second: '01',
  },
  { // 7
    title: 'The Product Space',
    minute: '3',
    second: '25',
  },
  { // 8
    title: 'A Recommended Approach to Growth',
    minute: '3',
    second: '58',
  },
  { // 9
    title: 'New Product Opportunities',
    minute: '5',
    second: '09',
  },
  { // 10
    title: 'Navigating the new product table',
    minute: '5',
    second: '51',
  },
];

interface Props {
  closeModal: () => void;
  initialTimeStamp: number;
}

const VideoTutorial = ({closeModal, initialTimeStamp}: Props) => {

  const [timeStamp, setTimeStamp] = useState<number>(initialTimeStamp);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  let videoString: string = 'KQAarHByMTM';
  if (isPlaying) {
    videoString += '?autoplay=1';
    if (timeStamp > 0) {
      videoString += `&start=${timeStamp}`;
    }
  } else if (initialTimeStamp === timeStamp && timeStamp > 0) {
    videoString += `?start=${timeStamp}`;
  }

  const chapterButtons = chapters.map(({title, minute, second}) => {
    const onClick = () => {
      setTimeStamp(timeToTimeStamp(minute, second));
      setIsPlaying(true);
    };
    return (
      <ContentButton key={title + minute + second} onClick={onClick}>
        <Time>{minute}:{second}</Time>
        <Title>{title}</Title>
      </ContentButton>
    );
  });

  return (
    <Root>
      <Overlay onClick={closeModal} />
      <TutorialContainer>
        <Grid>
          <YoutubeVideo
            id={videoString}
            onSucccesfulLoad={noop}
          />
          <TableOfContents>
            <TOCTitle>Table of Contents</TOCTitle>
            {chapterButtons}
          </TableOfContents>
        </Grid>
        <CloseButton onClick={closeModal}>×</CloseButton>
      </TutorialContainer>
    </Root>
  );
};

export default VideoTutorial;
